export enum ProductionLine {
    // Sections
    RaisedPanel         = 1,
    EightyThree         = 2,
    FoamRoom            = 3,
    FoamInPlace         = 4,
    Rib                 = 5,
    TwentySeven         = 6,
    FullView            = 7,
    FoamPack            = 8,
    AccentPack          = 9,
    CarriageHouse       = 10,
    RecessedPanel       = 11,
    // Subassembly (track, hardware, springs)
    ResidentialTrack    = 12,
    CommercialTrack     = 13,
    LowHeadRoomTrack    = 14,
    ResidentialSprings  = 15,
    CommercialSprings   = 16,
    Struts              = 17,
    Hardware            = 18,
    // Subassembly (windows)
    Windows             = 19,
    // Specialty
    PowderCoat          = 20,
    Print               = 21,
    SectionLoading      = 22,
    HardwareLoading     = 23,
    Fabrication         = 24,
    Hotwire             = 25,
    Samples             = 26,
    Stamping            = 27,
    SteelWarehouse      = 28,
    Infinity            = 29,
    // Unknown
    Unknown             = 9999
}

export const ProductionLineMetadata = {
    '1': {
        display: 'Raised Panel',
        abbr: 'RP',
        value: 1
    },
    '2': {
        display: 'Eighty Three',
        abbr: '83',
        value: 2
    },
    '3': {
        display: 'Foam Room',
        abbr: 'FR',
        value: 3
    },    
    '4': {
        display: 'Foam In Place',
        abbr: 'FIP',
        value: 4
    },
    '5': {
        display: 'Rib',
        abbr: 'RB',
        value: 5
    },
    '6': {
        display: 'Twenty Seven',
        abbr: '27',
        value: 6
    },
    '7': {
        display: 'Full View',
        abbr: 'FV',
        value: 7
    },
    '8': {
        display: 'Foam Pack',
        abbr: 'FP',
        value: 8
    },
    '9': {
        display: 'Accent Pack',
        abbr: 'AP',
        value: 9
    },
    '10': {
        display: 'Carriage House',
        abbr: 'CH',
        value: 10
    },
    '11': {
        display: 'Recessed Panel',
        abbr: 'RP',
        value: 11
    },
    '12': {
        display: 'Residential Track',
        abbr: 'RTT',
        value: 12
    },
    '13': {
        display: 'Commercial Track',
        abbr: 'CT',
        value: 13
    },
    '14': {
        display: 'Low Head Room Track',
        abbr: 'LHRT',
        value: 14
    },
    '15': {
        display: 'Residential Springs',
        abbr: 'RS',
        value: 15
    },
    '16': {
        display: 'Commercial Springs',
        abbr: 'CS',
        value: 16
    },
    '17': {
        display: 'Struts',
        abbr: 'STR',
        value: 17
    },
    '18': {
        display: 'Hardware',
        abbr: 'HW',
        value: 18
    },
    '19': {
        display: 'Windows',
        abbr: 'WIN',
        value: 19
    },
    '20': {
        display: 'Powder Coat',
        abbr: 'PC',
        value: 20
    },
    '21': {
        display: 'Print',
        abbr: 'PRNT',
        value: 21
    },
    '22': {
        display: 'Section Loading',
        abbr: 'SEC LD',
        value: 22
    },
    '23': {
        display: 'Hardware Loading',
        abbr: 'HW LD',
        value: 23
    },
    '29': {
        display: 'Infinity',
        abbr: 'I',
        value: 29
    }
};
